module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQtJREFUeNpi/P//PwM+cOfJKwUglQDEDlChA0C8QEVG7AE+fYz4DAYaCjJwAhDzo0l9BOICoOELSDYY6tILWAxFBoZAwy9gk2DCo6mBgKEgUIBLAp/BCgyEgQE5BhMDBMgx+AMRBl8gx+AJRBi8gGSDgbENSq8T8Ri6EKhmA1lhDNQIivVAIL6IJAxiJwLlEsjOIJQAJgYaAZoZzIKUhQWghU0AmWZtgBZOH+BhDDUUlAr0KXToQ5DDQOUHE5Jt+lQIAXlY+me8/fglKL+fp3IQGzLhy++UlCE0TW4XoDUCNcEFJmjyaKCioY0gM5mgZQIoJgspdPlHqKENWMsKYJp2INf7sMwBAgABBgCk9U+4bG4JwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/user.png
// module id = IPrZ
// module chunks = 1